// Backend URL (Cloud Run)
// const DEV_BACKEND = "http://localhost:8080";
export const BASE_URL =
	process.env.REACT_APP_BASE_URL || "";
//	process.env.REACT_APP_BASE_URL || "https://prod-potentia-backend-42500313696.asia-southeast2.run.app"; // Prod
//	process.env.REACT_APP_BASE_URL || "https://test-potentia-backend-43525642171.asia-southeast2.run.app";

// Firebase configuration
export const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCrrnDRqCqS6iQEjVhdenDmt4LjFeCHYGw", // Prod
//	apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC8jAN6kKMHD_reyFX6zxuOXEH_26AFbrA",
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "potentia-472407.firebaseapp.com", // Prod
//	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "testpotentia-a98f8.firebaseapp.com",
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "potentia-472407", // Prod
//	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "testpotentia-a98f8",
};
